
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3726"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3726"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $nNhvg = parcelRequire("nNhvg");

var $5jI6L = parcelRequire("5jI6L");

var $nNhvg = parcelRequire("nNhvg");

var $8jRlF = parcelRequire("8jRlF");
parcelRequire("2mLBt");

var $h3I9t = parcelRequire("h3I9t");

var $3NL81 = parcelRequire("3NL81");

var $nNhvg = parcelRequire("nNhvg");

var $8jRlF = parcelRequire("8jRlF");

var $jEyqx = parcelRequire("jEyqx");

var $hrlXl = parcelRequire("hrlXl");

var $5aXlP = parcelRequire("5aXlP");

var $gUqIv = parcelRequire("gUqIv");

var $3NL81 = parcelRequire("3NL81");
function $f9f9b2db1313b9af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9f9b2db1313b9af$export$54adcc344e3cab6a = [
    178,
    180,
    181
];
const $f9f9b2db1313b9af$var$TagSpan = /*#__PURE__*/ (0, $8jRlF.default)("span", {
    target: "e18xmz9l0"
})("border:1px dotted gray;border-radius:0.25rem;background-color:", (0, $gUqIv.darken)(0.1, "white"), ";font-size:90%;padding:0.1rem;");
function $f9f9b2db1313b9af$var$ScriptTitleTags({ script: script }) {
    // TODO: normalizing these ids is an ugly hack, we should standardize on
    // script tool IDs
    const chars = (0, $5aXlP.getCharacterList)(script.characters.map((id)=>(0, $hrlXl.nameToId)(id)));
    return /*#__PURE__*/ (0, $nNhvg.jsxs)((0, $nNhvg.Fragment), {
        children: [
            /*#__PURE__*/ (0, $nNhvg.jsx)("a", {
                href: (0, $3NL81.pageUrl)("roles", script.pk),
                children: script.title
            }),
            (0, $5aXlP.isTeensyville)(chars) && /*#__PURE__*/ (0, $nNhvg.jsxs)((0, $nNhvg.Fragment), {
                children: [
                    "\xa0",
                    /*#__PURE__*/ (0, $nNhvg.jsx)($f9f9b2db1313b9af$var$TagSpan, {
                        children: "teensy"
                    })
                ]
            }),
            (0, $5aXlP.onlyBaseThree)(chars) && !$f9f9b2db1313b9af$export$54adcc344e3cab6a.includes(script.pk) && /*#__PURE__*/ (0, $nNhvg.jsxs)((0, $nNhvg.Fragment), {
                children: [
                    "\xa0",
                    /*#__PURE__*/ (0, $nNhvg.jsx)($f9f9b2db1313b9af$var$TagSpan, {
                        children: "base3"
                    })
                ]
            })
        ]
    });
}
const $f9f9b2db1313b9af$var$listStyle = {
    name: "oey8wy",
    styles: "font-size:120%;li:not(:last-of-type){padding-bottom:0.5rem;}"
};
function $f9f9b2db1313b9af$export$3e15fc05ce864229(props) {
    return /*#__PURE__*/ (0, $nNhvg.jsx)("ul", {
        css: $f9f9b2db1313b9af$var$listStyle,
        children: props.scripts.map((script)=>{
            return /*#__PURE__*/ (0, $nNhvg.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $nNhvg.jsx)((0, $jEyqx.FontAwesomeIcon), {
                        icon: "table-list"
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0, $nNhvg.jsx)($f9f9b2db1313b9af$var$ScriptTitleTags, {
                        script: script
                    })
                ]
            }, script.pk);
        })
    });
}



var $hrlXl = parcelRequire("hrlXl");
var $034c85cbf1b980af$exports = {};
var $034c85cbf1b980af$var$characterMap = {
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\u1EA4": "A",
    "\u1EAE": "A",
    "\u1EB2": "A",
    "\u1EB4": "A",
    "\u1EB6": "A",
    "\xc6": "AE",
    "\u1EA6": "A",
    "\u1EB0": "A",
    "\u0202": "A",
    "\u1EA2": "A",
    "\u1EA0": "A",
    "\u1EA8": "A",
    "\u1EAA": "A",
    "\u1EAC": "A",
    "\xc7": "C",
    "\u1E08": "C",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\u1EBE": "E",
    "\u1E16": "E",
    "\u1EC0": "E",
    "\u1E14": "E",
    "\u1E1C": "E",
    "\u0206": "E",
    "\u1EBA": "E",
    "\u1EBC": "E",
    "\u1EB8": "E",
    "\u1EC2": "E",
    "\u1EC4": "E",
    "\u1EC6": "E",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\u1E2E": "I",
    "\u020A": "I",
    "\u1EC8": "I",
    "\u1ECA": "I",
    "\xd0": "D",
    "\xd1": "N",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\u1ED0": "O",
    "\u1E4C": "O",
    "\u1E52": "O",
    "\u020E": "O",
    "\u1ECE": "O",
    "\u1ECC": "O",
    "\u1ED4": "O",
    "\u1ED6": "O",
    "\u1ED8": "O",
    "\u1EDC": "O",
    "\u1EDE": "O",
    "\u1EE0": "O",
    "\u1EDA": "O",
    "\u1EE2": "O",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\u1EE6": "U",
    "\u1EE4": "U",
    "\u1EEC": "U",
    "\u1EEE": "U",
    "\u1EF0": "U",
    "\xdd": "Y",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\u1EA5": "a",
    "\u1EAF": "a",
    "\u1EB3": "a",
    "\u1EB5": "a",
    "\u1EB7": "a",
    "\xe6": "ae",
    "\u1EA7": "a",
    "\u1EB1": "a",
    "\u0203": "a",
    "\u1EA3": "a",
    "\u1EA1": "a",
    "\u1EA9": "a",
    "\u1EAB": "a",
    "\u1EAD": "a",
    "\xe7": "c",
    "\u1E09": "c",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\u1EBF": "e",
    "\u1E17": "e",
    "\u1EC1": "e",
    "\u1E15": "e",
    "\u1E1D": "e",
    "\u0207": "e",
    "\u1EBB": "e",
    "\u1EBD": "e",
    "\u1EB9": "e",
    "\u1EC3": "e",
    "\u1EC5": "e",
    "\u1EC7": "e",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\u1E2F": "i",
    "\u020B": "i",
    "\u1EC9": "i",
    "\u1ECB": "i",
    "\xf0": "d",
    "\xf1": "n",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\u1ED1": "o",
    "\u1E4D": "o",
    "\u1E53": "o",
    "\u020F": "o",
    "\u1ECF": "o",
    "\u1ECD": "o",
    "\u1ED5": "o",
    "\u1ED7": "o",
    "\u1ED9": "o",
    "\u1EDD": "o",
    "\u1EDF": "o",
    "\u1EE1": "o",
    "\u1EDB": "o",
    "\u1EE3": "o",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\u1EE7": "u",
    "\u1EE5": "u",
    "\u1EED": "u",
    "\u1EEF": "u",
    "\u1EF1": "u",
    "\xfd": "y",
    "\xff": "y",
    "\u0100": "A",
    "\u0101": "a",
    "\u0102": "A",
    "\u0103": "a",
    "\u0104": "A",
    "\u0105": "a",
    "\u0106": "C",
    "\u0107": "c",
    "\u0108": "C",
    "\u0109": "c",
    "\u010A": "C",
    "\u010B": "c",
    "\u010C": "C",
    "\u010D": "c",
    "C\u0306": "C",
    "c\u0306": "c",
    "\u010E": "D",
    "\u010F": "d",
    "\u0110": "D",
    "\u0111": "d",
    "\u0112": "E",
    "\u0113": "e",
    "\u0114": "E",
    "\u0115": "e",
    "\u0116": "E",
    "\u0117": "e",
    "\u0118": "E",
    "\u0119": "e",
    "\u011A": "E",
    "\u011B": "e",
    "\u011C": "G",
    "\u01F4": "G",
    "\u011D": "g",
    "\u01F5": "g",
    "\u011E": "G",
    "\u011F": "g",
    "\u0120": "G",
    "\u0121": "g",
    "\u0122": "G",
    "\u0123": "g",
    "\u0124": "H",
    "\u0125": "h",
    "\u0126": "H",
    "\u0127": "h",
    "\u1E2A": "H",
    "\u1E2B": "h",
    "\u0128": "I",
    "\u0129": "i",
    "\u012A": "I",
    "\u012B": "i",
    "\u012C": "I",
    "\u012D": "i",
    "\u012E": "I",
    "\u012F": "i",
    "\u0130": "I",
    "\u0131": "i",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u1E30": "K",
    "\u1E31": "k",
    "K\u0306": "K",
    "k\u0306": "k",
    "\u0139": "L",
    "\u013A": "l",
    "\u013B": "L",
    "\u013C": "l",
    "\u013D": "L",
    "\u013E": "l",
    "\u013F": "L",
    "\u0140": "l",
    "\u0141": "l",
    "\u0142": "l",
    "\u1E3E": "M",
    "\u1E3F": "m",
    "M\u0306": "M",
    "m\u0306": "m",
    "\u0143": "N",
    "\u0144": "n",
    "\u0145": "N",
    "\u0146": "n",
    "\u0147": "N",
    "\u0148": "n",
    "\u0149": "n",
    "N\u0306": "N",
    "n\u0306": "n",
    "\u014C": "O",
    "\u014D": "o",
    "\u014E": "O",
    "\u014F": "o",
    "\u0150": "O",
    "\u0151": "o",
    "\u0152": "OE",
    "\u0153": "oe",
    "P\u0306": "P",
    "p\u0306": "p",
    "\u0154": "R",
    "\u0155": "r",
    "\u0156": "R",
    "\u0157": "r",
    "\u0158": "R",
    "\u0159": "r",
    "R\u0306": "R",
    "r\u0306": "r",
    "\u0212": "R",
    "\u0213": "r",
    "\u015A": "S",
    "\u015B": "s",
    "\u015C": "S",
    "\u015D": "s",
    "\u015E": "S",
    "\u0218": "S",
    "\u0219": "s",
    "\u015F": "s",
    "\u0160": "S",
    "\u0161": "s",
    "\u0162": "T",
    "\u0163": "t",
    "\u021B": "t",
    "\u021A": "T",
    "\u0164": "T",
    "\u0165": "t",
    "\u0166": "T",
    "\u0167": "t",
    "T\u0306": "T",
    "t\u0306": "t",
    "\u0168": "U",
    "\u0169": "u",
    "\u016A": "U",
    "\u016B": "u",
    "\u016C": "U",
    "\u016D": "u",
    "\u016E": "U",
    "\u016F": "u",
    "\u0170": "U",
    "\u0171": "u",
    "\u0172": "U",
    "\u0173": "u",
    "\u0216": "U",
    "\u0217": "u",
    "V\u0306": "V",
    "v\u0306": "v",
    "\u0174": "W",
    "\u0175": "w",
    "\u1E82": "W",
    "\u1E83": "w",
    "X\u0306": "X",
    "x\u0306": "x",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "Y\u0306": "Y",
    "y\u0306": "y",
    "\u0179": "Z",
    "\u017A": "z",
    "\u017B": "Z",
    "\u017C": "z",
    "\u017D": "Z",
    "\u017E": "z",
    "\u017F": "s",
    "\u0192": "f",
    "\u01A0": "O",
    "\u01A1": "o",
    "\u01AF": "U",
    "\u01B0": "u",
    "\u01CD": "A",
    "\u01CE": "a",
    "\u01CF": "I",
    "\u01D0": "i",
    "\u01D1": "O",
    "\u01D2": "o",
    "\u01D3": "U",
    "\u01D4": "u",
    "\u01D5": "U",
    "\u01D6": "u",
    "\u01D7": "U",
    "\u01D8": "u",
    "\u01D9": "U",
    "\u01DA": "u",
    "\u01DB": "U",
    "\u01DC": "u",
    "\u1EE8": "U",
    "\u1EE9": "u",
    "\u1E78": "U",
    "\u1E79": "u",
    "\u01FA": "A",
    "\u01FB": "a",
    "\u01FC": "AE",
    "\u01FD": "ae",
    "\u01FE": "O",
    "\u01FF": "o",
    "\xde": "TH",
    "\xfe": "th",
    "\u1E54": "P",
    "\u1E55": "p",
    "\u1E64": "S",
    "\u1E65": "s",
    "X\u0301": "X",
    "x\u0301": "x",
    "\u0403": "\u0413",
    "\u0453": "\u0433",
    "\u040C": "\u041A",
    "\u045C": "\u043A",
    "A\u030B": "A",
    "a\u030B": "a",
    "E\u030B": "E",
    "e\u030B": "e",
    "I\u030B": "I",
    "i\u030B": "i",
    "\u01F8": "N",
    "\u01F9": "n",
    "\u1ED2": "O",
    "\u1ED3": "o",
    "\u1E50": "O",
    "\u1E51": "o",
    "\u1EEA": "U",
    "\u1EEB": "u",
    "\u1E80": "W",
    "\u1E81": "w",
    "\u1EF2": "Y",
    "\u1EF3": "y",
    "\u0200": "A",
    "\u0201": "a",
    "\u0204": "E",
    "\u0205": "e",
    "\u0208": "I",
    "\u0209": "i",
    "\u020C": "O",
    "\u020D": "o",
    "\u0210": "R",
    "\u0211": "r",
    "\u0214": "U",
    "\u0215": "u",
    "B\u030C": "B",
    "b\u030C": "b",
    "\u010C\u0323": "C",
    "\u010D\u0323": "c",
    "\xca\u030C": "E",
    "\xea\u030C": "e",
    "F\u030C": "F",
    "f\u030C": "f",
    "\u01E6": "G",
    "\u01E7": "g",
    "\u021E": "H",
    "\u021F": "h",
    "J\u030C": "J",
    "\u01F0": "j",
    "\u01E8": "K",
    "\u01E9": "k",
    "M\u030C": "M",
    "m\u030C": "m",
    "P\u030C": "P",
    "p\u030C": "p",
    "Q\u030C": "Q",
    "q\u030C": "q",
    "\u0158\u0329": "R",
    "\u0159\u0329": "r",
    "\u1E66": "S",
    "\u1E67": "s",
    "V\u030C": "V",
    "v\u030C": "v",
    "W\u030C": "W",
    "w\u030C": "w",
    "X\u030C": "X",
    "x\u030C": "x",
    "Y\u030C": "Y",
    "y\u030C": "y",
    "A\u0327": "A",
    "a\u0327": "a",
    "B\u0327": "B",
    "b\u0327": "b",
    "\u1E10": "D",
    "\u1E11": "d",
    "\u0228": "E",
    "\u0229": "e",
    "\u0190\u0327": "E",
    "\u025B\u0327": "e",
    "\u1E28": "H",
    "\u1E29": "h",
    "I\u0327": "I",
    "i\u0327": "i",
    "\u0197\u0327": "I",
    "\u0268\u0327": "i",
    "M\u0327": "M",
    "m\u0327": "m",
    "O\u0327": "O",
    "o\u0327": "o",
    "Q\u0327": "Q",
    "q\u0327": "q",
    "U\u0327": "U",
    "u\u0327": "u",
    "X\u0327": "X",
    "x\u0327": "x",
    "Z\u0327": "Z",
    "z\u0327": "z",
    "\u0439": "\u0438",
    "\u0419": "\u0418",
    "\u0451": "\u0435",
    "\u0401": "\u0415"
};
var $034c85cbf1b980af$var$chars = Object.keys($034c85cbf1b980af$var$characterMap).join("|");
var $034c85cbf1b980af$var$allAccents = new RegExp($034c85cbf1b980af$var$chars, "g");
var $034c85cbf1b980af$var$firstAccent = new RegExp($034c85cbf1b980af$var$chars, "");
function $034c85cbf1b980af$var$matcher(match) {
    return $034c85cbf1b980af$var$characterMap[match];
}
var $034c85cbf1b980af$var$removeAccents = function(string) {
    return string.replace($034c85cbf1b980af$var$allAccents, $034c85cbf1b980af$var$matcher);
};
var $034c85cbf1b980af$var$hasAccents = function(string) {
    return !!string.match($034c85cbf1b980af$var$firstAccent);
};
$034c85cbf1b980af$exports = $034c85cbf1b980af$var$removeAccents;
$034c85cbf1b980af$exports.has = $034c85cbf1b980af$var$hasAccents;
$034c85cbf1b980af$exports.remove = $034c85cbf1b980af$var$removeAccents;


/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2020 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */ const $e7f26546e05b06c9$export$809b0b82a3f0b8b5 = {
    CASE_SENSITIVE_EQUAL: 7,
    EQUAL: 6,
    STARTS_WITH: 5,
    WORD_STARTS_WITH: 4,
    CONTAINS: 3,
    ACRONYM: 2,
    MATCHES: 1,
    NO_MATCH: 0
};
const $e7f26546e05b06c9$export$dc3d084526f616f2 = (a, b)=>String(a.rankedValue).localeCompare(String(b.rankedValue));
/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */ function $e7f26546e05b06c9$export$9e154eccb89349f0(items, value, options) {
    if (options === void 0) options = {};
    const { keys: keys, threshold: threshold = $e7f26546e05b06c9$export$809b0b82a3f0b8b5.MATCHES, baseSort: baseSort = $e7f26546e05b06c9$export$dc3d084526f616f2, sorter: sorter = (matchedItems)=>matchedItems.sort((a, b)=>$e7f26546e05b06c9$var$sortRankedValues(a, b, baseSort)) } = options;
    const matchedItems = items.reduce(reduceItemsToRanked, []);
    return sorter(matchedItems).map((_ref)=>{
        let { item: item } = _ref;
        return item;
    });
    function reduceItemsToRanked(matches, item, index) {
        const rankingInfo = $e7f26546e05b06c9$var$getHighestRanking(item, keys, value, options);
        const { rank: rank, keyThreshold: keyThreshold = threshold } = rankingInfo;
        if (rank >= keyThreshold) matches.push({
            ...rankingInfo,
            item: item,
            index: index
        });
        return matches;
    }
}
$e7f26546e05b06c9$export$9e154eccb89349f0.rankings = $e7f26546e05b06c9$export$809b0b82a3f0b8b5;
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */ function $e7f26546e05b06c9$var$getHighestRanking(item, keys, value, options) {
    if (!keys) {
        // if keys is not specified, then we assume the item given is ready to be matched
        const stringItem = item;
        return {
            // ends up being duplicate of 'item' in matches but consistent
            rankedValue: stringItem,
            rank: $e7f26546e05b06c9$var$getMatchRanking(stringItem, value, options),
            keyIndex: -1,
            keyThreshold: options.threshold
        };
    }
    const valuesToRank = $e7f26546e05b06c9$var$getAllValuesToRank(item, keys);
    return valuesToRank.reduce((_ref2, _ref3, i)=>{
        let { rank: rank, rankedValue: rankedValue, keyIndex: keyIndex, keyThreshold: keyThreshold } = _ref2;
        let { itemValue: itemValue, attributes: attributes } = _ref3;
        let newRank = $e7f26546e05b06c9$var$getMatchRanking(itemValue, value, options);
        let newRankedValue = rankedValue;
        const { minRanking: minRanking, maxRanking: maxRanking, threshold: threshold } = attributes;
        if (newRank < minRanking && newRank >= $e7f26546e05b06c9$export$809b0b82a3f0b8b5.MATCHES) newRank = minRanking;
        else if (newRank > maxRanking) newRank = maxRanking;
        if (newRank > rank) {
            rank = newRank;
            keyIndex = i;
            keyThreshold = threshold;
            newRankedValue = itemValue;
        }
        return {
            rankedValue: newRankedValue,
            rank: rank,
            keyIndex: keyIndex,
            keyThreshold: keyThreshold
        };
    }, {
        rankedValue: item,
        rank: $e7f26546e05b06c9$export$809b0b82a3f0b8b5.NO_MATCH,
        keyIndex: -1,
        keyThreshold: options.threshold
    });
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */ function $e7f26546e05b06c9$var$getMatchRanking(testString, stringToRank, options) {
    testString = $e7f26546e05b06c9$var$prepareValueForComparison(testString, options);
    stringToRank = $e7f26546e05b06c9$var$prepareValueForComparison(stringToRank, options);
    // too long
    if (stringToRank.length > testString.length) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.NO_MATCH;
    // case sensitive equals
    if (testString === stringToRank) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.CASE_SENSITIVE_EQUAL;
    // Lower casing before further comparison
    testString = testString.toLowerCase();
    stringToRank = stringToRank.toLowerCase();
    // case insensitive equals
    if (testString === stringToRank) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.EQUAL;
    // starts with
    if (testString.startsWith(stringToRank)) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.STARTS_WITH;
    // word starts with
    if (testString.includes(` ${stringToRank}`)) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.WORD_STARTS_WITH;
    // contains
    if (testString.includes(stringToRank)) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.CONTAINS;
    else if (stringToRank.length === 1) // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.NO_MATCH;
    // acronym
    if ($e7f26546e05b06c9$var$getAcronym(testString).includes(stringToRank)) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.ACRONYM;
    // will return a number between rankings.MATCHES and
    // rankings.MATCHES + 1 depending  on how close of a match it is.
    return $e7f26546e05b06c9$var$getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */ function $e7f26546e05b06c9$var$getAcronym(string) {
    let acronym = "";
    const wordsInString = string.split(" ");
    wordsInString.forEach((wordInString)=>{
        const splitByHyphenWords = wordInString.split("-");
        splitByHyphenWords.forEach((splitByHyphenWord)=>{
            acronym += splitByHyphenWord.substr(0, 1);
        });
    });
    return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */ function $e7f26546e05b06c9$var$getClosenessRanking(testString, stringToRank) {
    let matchingInOrderCharCount = 0;
    let charNumber = 0;
    function findMatchingCharacter(matchChar, string, index) {
        for(let j = index, J = string.length; j < J; j++){
            const stringChar = string[j];
            if (stringChar === matchChar) {
                matchingInOrderCharCount += 1;
                return j + 1;
            }
        }
        return -1;
    }
    function getRanking(spread) {
        const spreadPercentage = 1 / spread;
        const inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
        const ranking = $e7f26546e05b06c9$export$809b0b82a3f0b8b5.MATCHES + inOrderPercentage * spreadPercentage;
        return ranking;
    }
    const firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
    if (firstIndex < 0) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.NO_MATCH;
    charNumber = firstIndex;
    for(let i = 1, I = stringToRank.length; i < I; i++){
        const matchChar = stringToRank[i];
        charNumber = findMatchingCharacter(matchChar, testString, charNumber);
        const found = charNumber > -1;
        if (!found) return $e7f26546e05b06c9$export$809b0b82a3f0b8b5.NO_MATCH;
    }
    const spread = charNumber - firstIndex;
    return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */ function $e7f26546e05b06c9$var$sortRankedValues(a, b, baseSort) {
    const aFirst = -1;
    const bFirst = 1;
    const { rank: aRank, keyIndex: aKeyIndex } = a;
    const { rank: bRank, keyIndex: bKeyIndex } = b;
    const same = aRank === bRank;
    if (same) {
        if (aKeyIndex === bKeyIndex) // use the base sort function as a tie-breaker
        return baseSort(a, b);
        else return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    } else return aRank > bRank ? aFirst : bFirst;
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */ function $e7f26546e05b06c9$var$prepareValueForComparison(value, _ref4) {
    let { keepDiacritics: keepDiacritics } = _ref4;
    // value might not actually be a string at this point (we don't get to choose)
    // so part of preparing the value for comparison is ensure that it is a string
    value = `${value}`; // toString
    if (!keepDiacritics) value = (0, (/*@__PURE__*/$parcel$interopDefault($034c85cbf1b980af$exports)))(value);
    return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */ function $e7f26546e05b06c9$var$getItemValues(item, key) {
    if (typeof key === "object") key = key.key;
    let value;
    if (typeof key === "function") value = key(item);
    else if (item == null) value = null;
    else if (Object.hasOwnProperty.call(item, key)) value = item[key];
    else if (key.includes(".")) // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return $e7f26546e05b06c9$var$getNestedValues(key, item);
    else value = null;
    // because `value` can also be undefined
    if (value == null) return [];
    if (Array.isArray(value)) return value;
    return [
        String(value)
    ];
}
/**
 * Given path: "foo.bar.baz"
 * And item: {foo: {bar: {baz: 'buzz'}}}
 *   -> 'buzz'
 * @param path a dot-separated set of keys
 * @param item the item to get the value from
 */ function $e7f26546e05b06c9$var$getNestedValues(path, item) {
    const keys = path.split(".");
    let values = [
        item
    ];
    for(let i = 0, I = keys.length; i < I; i++){
        const nestedKey = keys[i];
        let nestedValues = [];
        for(let j = 0, J = values.length; j < J; j++){
            const nestedItem = values[j];
            if (nestedItem == null) continue;
            if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
                const nestedValue = nestedItem[nestedKey];
                if (nestedValue != null) nestedValues.push(nestedValue);
            } else if (nestedKey === "*") // ensure that values is an array
            nestedValues = nestedValues.concat(nestedItem);
        }
        values = nestedValues;
    }
    if (Array.isArray(values[0])) {
        // keep allowing the implicit wildcard for an array of strings at the end of
        // the path; don't use `.flat()` because that's not available in node.js v10
        const result = [];
        return result.concat(...values);
    }
    // Based on our logic it should be an array of strings by now...
    // assuming the user's path terminated in strings
    return values;
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */ function $e7f26546e05b06c9$var$getAllValuesToRank(item, keys) {
    const allValues = [];
    for(let j = 0, J = keys.length; j < J; j++){
        const key = keys[j];
        const attributes = $e7f26546e05b06c9$var$getKeyAttributes(key);
        const itemValues = $e7f26546e05b06c9$var$getItemValues(item, key);
        for(let i = 0, I = itemValues.length; i < I; i++)allValues.push({
            itemValue: itemValues[i],
            attributes: attributes
        });
    }
    return allValues;
}
const $e7f26546e05b06c9$var$defaultKeyAttributes = {
    maxRanking: Infinity,
    minRanking: -Infinity
};
/**
 * Gets all the attributes for the given key
 * @param key - the key from which the attributes will be retrieved
 * @return object containing the key's attributes
 */ function $e7f26546e05b06c9$var$getKeyAttributes(key) {
    if (typeof key === "string") return $e7f26546e05b06c9$var$defaultKeyAttributes;
    return {
        ...$e7f26546e05b06c9$var$defaultKeyAttributes,
        ...key
    };
}


const $86b312579ea6ab09$var$FAVORITE_TITLES = new Set([
    "Catfishing",
    "No Roles Barred",
    "Whose Cult Is It Anyway?",
    "Creme De La Creme",
    "Laissez un Faire",
    "High Stakes Betting",
    "Race to the Bottom",
    "Pies Baking"
]);
function $86b312579ea6ab09$var$characterList(script) {
    const characters = [];
    for (const id of script.characters){
        const char = (0, $hrlXl.roles).get((0, $hrlXl.nameToId)(id));
        if (char !== undefined) characters.push(char.name);
    }
    return characters;
}
// match scripts that have a list of characters
function $86b312579ea6ab09$var$characterQueryMatches(characters, scripts) {
    const terms = characters.split(" ");
    return terms.reduceRight((results, char)=>(0, $e7f26546e05b06c9$export$9e154eccb89349f0)(results, char.replace("-", ""), {
            keys: [
                $86b312579ea6ab09$var$characterList
            ]
        }), scripts);
}
function $86b312579ea6ab09$export$1691647bc8e4cc06(scripts, query) {
    let matches;
    if (query == "") matches = scripts.filter((s)=>$86b312579ea6ab09$var$FAVORITE_TITLES.has(s.title));
    else {
        matches = (0, $e7f26546e05b06c9$export$9e154eccb89349f0)(scripts, query, {
            keys: [
                "title",
                "author"
            ]
        });
        if (matches.length < 10) // fill in results with character-based search
        matches.push(...$86b312579ea6ab09$var$characterQueryMatches(query, // start with non-matching scripts
        scripts.filter((s)=>!matches.some((m)=>m.pk == s.pk))));
    }
    return matches;
}
function $86b312579ea6ab09$export$bbd3890ed397f36c(query) {
    return query.toLowerCase().replaceAll(/ +/g, " ").replaceAll(/[']/g, "");
}



var $nNhvg = parcelRequire("nNhvg");



var $jEyqx = parcelRequire("jEyqx");
function $eedf89cd266fc210$export$95df08bae54cb4df() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}


function $dbe52e5def8afa3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $dbe52e5def8afa3a$var$_ref = {
    name: "9brm5d",
    styles: "font-size:inherit;width:8rem;transition:width 0.3s;&:focus{width:15rem;}"
};
var $dbe52e5def8afa3a$var$_ref2 = {
    name: "11p8enk",
    styles: "font-size:120%;margin-bottom:0.5rem"
};
var $dbe52e5def8afa3a$var$_ref3 = {
    name: "w8yiws",
    styles: "color:gray"
};
function $dbe52e5def8afa3a$export$aee53da69e9839be(props) {
    const { scripts: scripts, query: query, setQuery: setQuery } = props;
    // on Safari the search box already has a magnifying glass icon so avoid
    // adding a redundant one
    const showSearchIcon = !(0, $eedf89cd266fc210$export$95df08bae54cb4df)();
    function queryChange(v) {
        const newQuery = v.target.value;
        setQuery(newQuery);
        window.location.hash = (0, $86b312579ea6ab09$export$bbd3890ed397f36c)(newQuery);
    }
    const allResults = (0, $86b312579ea6ab09$export$1691647bc8e4cc06)(scripts, query);
    const results = allResults.slice(0, 20);
    const extraResults = allResults.slice(20);
    return /*#__PURE__*/ (0, $nNhvg.jsxs)((0, $nNhvg.Fragment), {
        children: [
            /*#__PURE__*/ (0, $nNhvg.jsxs)("div", {
                id: "search",
                css: $dbe52e5def8afa3a$var$_ref2,
                children: [
                    /*#__PURE__*/ (0, $nNhvg.jsx)("input", {
                        id: "search-query",
                        type: "search",
                        placeholder: "search",
                        value: query,
                        onChange: queryChange,
                        css: $dbe52e5def8afa3a$var$_ref
                    }),
                    showSearchIcon && /*#__PURE__*/ (0, $nNhvg.jsxs)((0, $nNhvg.Fragment), {
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0, $nNhvg.jsx)("span", {
                                css: $dbe52e5def8afa3a$var$_ref3,
                                children: /*#__PURE__*/ (0, $nNhvg.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                    icon: "search"
                                })
                            })
                        ]
                    })
                ]
            }),
            allResults.length == 0 && /*#__PURE__*/ (0, $nNhvg.jsx)("span", {
                children: "No results"
            }),
            /*#__PURE__*/ (0, $nNhvg.jsx)((0, $f9f9b2db1313b9af$export$3e15fc05ce864229), {
                scripts: results
            }),
            extraResults.length > 0 && /*#__PURE__*/ (0, $nNhvg.jsxs)("span", {
                children: [
                    "... plus ",
                    extraResults.length,
                    " more"
                ]
            })
        ]
    });
}



var $8zogs = parcelRequire("8zogs");
var $dW2n4 = parcelRequire("dW2n4");

var $jEyqx = parcelRequire("jEyqx");

var $exXH6 = parcelRequire("exXH6");

var $gUqIv = parcelRequire("gUqIv");

var $acw62 = parcelRequire("acw62");

var $j4XaA = parcelRequire("j4XaA");
function $d90584698df86283$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d90584698df86283$export$6d90db48325da75 = {
    name: "ocw40m",
    styles: "h2{margin-top:1rem;margin-bottom:0.5rem;}a,a:visited{color:rgb(16, 93, 216);}"
};



var $hIYVk = parcelRequire("hIYVk");
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $e24aa25ccaa7cb1c$export$dfd9b671c89acc8e = 7;
const $e24aa25ccaa7cb1c$export$3913210603d8e9ae = 365.2425;
const $e24aa25ccaa7cb1c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $e24aa25ccaa7cb1c$export$4dec998e48f9c246 = -$e24aa25ccaa7cb1c$export$81caae6e1cc7a622;
const $e24aa25ccaa7cb1c$export$4fad13613e88edc8 = 604800000;
const $e24aa25ccaa7cb1c$export$b76b1809a2898f9a = 86400000;
const $e24aa25ccaa7cb1c$export$91246f0b9bd9beff = 60000;
const $e24aa25ccaa7cb1c$export$7f72910d6dfd237a = 3600000;
const $e24aa25ccaa7cb1c$export$397c2d5776aa9055 = 1000;
const $e24aa25ccaa7cb1c$export$3633035e63cee86a = 525600;
const $e24aa25ccaa7cb1c$export$ab7da2ccd1075c38 = 43200;
const $e24aa25ccaa7cb1c$export$2423174df8cd3cd2 = 1440;
const $e24aa25ccaa7cb1c$export$f2f5ae5a8e2d8f9f = 60;
const $e24aa25ccaa7cb1c$export$3c58128db900d44e = 3;
const $e24aa25ccaa7cb1c$export$80d7e435f744f319 = 12;
const $e24aa25ccaa7cb1c$export$4db7641526e3241f = 4;
const $e24aa25ccaa7cb1c$export$698aec755e92c695 = 3600;
const $e24aa25ccaa7cb1c$export$a77c1a7ebebe2a5a = 60;
const $e24aa25ccaa7cb1c$export$815a9362476d2fe3 = $e24aa25ccaa7cb1c$export$698aec755e92c695 * 24;
const $e24aa25ccaa7cb1c$export$34804a017b31e2fe = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * 7;
const $e24aa25ccaa7cb1c$export$7271e9e3478110d1 = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * $e24aa25ccaa7cb1c$export$3913210603d8e9ae;
const $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb = $e24aa25ccaa7cb1c$export$7271e9e3478110d1 / 12;
const $e24aa25ccaa7cb1c$export$be1dccf2de902d31 = $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb * 3;


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $77dc29417ac8d032$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$77dc29417ac8d032$export$2e2bcd8739ae039 = $77dc29417ac8d032$export$e67a095c620b86fe;


function $08eadd31071dba99$export$63fa379ae8a9ba2(date) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$08eadd31071dba99$export$2e2bcd8739ae039 = $08eadd31071dba99$export$63fa379ae8a9ba2;



function $39c386bf2b2d4be8$export$113002b5eff6e430(date) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


function $30481ff49751e85f$export$4a02e9c37dab4871(dateLeft, dateRight) {
    const startOfDayLeft = (0, $08eadd31071dba99$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $08eadd31071dba99$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, $e24aa25ccaa7cb1c$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$30481ff49751e85f$export$2e2bcd8739ae039 = $30481ff49751e85f$export$4a02e9c37dab4871;



function $beed7bfc27ef6789$export$86415ebf4eb36b8c(dateLeft, dateRight) {
    const _dateLeft = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(dateRight);
    const sign = $beed7bfc27ef6789$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $30481ff49751e85f$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($beed7bfc27ef6789$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $beed7bfc27ef6789$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
var // Fallback for modularized imports:
$beed7bfc27ef6789$export$2e2bcd8739ae039 = $beed7bfc27ef6789$export$86415ebf4eb36b8c;


function $1f805259eb2a0f16$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f805259eb2a0f16$var$BtnSpan = /*#__PURE__*/ (0, $8jRlF.default)("span", {
    target: "e1o76wsj2"
})("padding:0.4rem 0.5rem;border-radius:0.25rem;background-color:", (props)=>props.theme.color.primary, ";color:white;");
const $1f805259eb2a0f16$var$BtnLink = /*#__PURE__*/ (0, $8jRlF.default)($1f805259eb2a0f16$var$BtnSpan.withComponent("a", {
    target: "e1o76wsj3"
}), {
    target: "e1o76wsj1"
})("&:hover{background-color:", (props)=>(0, $gUqIv.lighten)(0.2, props.theme.color.primary), ";}&:hover,&:visited{color:white;text-decoration:none;}");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var $1f805259eb2a0f16$var$_ref3 = {
    name: "1dnxkkn",
    styles: "&.disabled{display:none;}background-color:lightgreen;color:black;line-height:2rem;margin-bottom:1rem"
};
function $1f805259eb2a0f16$var$UpdateBar() {
    // Set disabled class to hide the bar.
    //
    // Need to hook up to service worker events, and offer a refresh button.
    return /*#__PURE__*/ (0, $nNhvg.jsx)("div", {
        css: $1f805259eb2a0f16$var$_ref3,
        children: /*#__PURE__*/ (0, $nNhvg.jsx)("div", {
            className: "main",
            children: "A new version is available. Close all tabs to restart."
        })
    });
}
var $1f805259eb2a0f16$var$_ref2 = {
    name: "h2z2sc",
    styles: "li:not(:last-of-type){padding-bottom:1rem;}"
};
function $1f805259eb2a0f16$var$HelpText() {
    const buttonHelp = [
        /*#__PURE__*/ (0, $nNhvg.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $nNhvg.jsxs)($1f805259eb2a0f16$var$BtnSpan, {
                    children: [
                        /*#__PURE__*/ (0, $nNhvg.jsx)((0, $jEyqx.FontAwesomeIcon), {
                            icon: "list"
                        }),
                        "\xa0 Roles"
                    ]
                }),
                "\xa0 is a character sheet"
            ]
        }, "roles"),
        /*#__PURE__*/ (0, $nNhvg.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $nNhvg.jsxs)($1f805259eb2a0f16$var$BtnSpan, {
                    children: [
                        /*#__PURE__*/ (0, $nNhvg.jsx)((0, $jEyqx.FontAwesomeIcon), {
                            icon: "moon"
                        }),
                        "\xa0 Night"
                    ]
                }),
                "\xa0 lists the night order"
            ]
        }, "night"),
        /*#__PURE__*/ (0, $nNhvg.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $nNhvg.jsxs)($1f805259eb2a0f16$var$BtnSpan, {
                    children: [
                        /*#__PURE__*/ (0, $nNhvg.jsx)((0, $jEyqx.FontAwesomeIcon), {
                            icon: "dice"
                        }),
                        "\xa0 Assign"
                    ]
                }),
                "\xa0 helps the ST select & assign roles"
            ]
        }, "assign")
    ];
    return /*#__PURE__*/ (0, $nNhvg.jsxs)("ul", {
        className: "help",
        css: [
            "margin-top:3rem;",
            $1f805259eb2a0f16$var$_ref2,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $nNhvg.jsx)("li", {
                children: "Each script has these tools:"
            }),
            buttonHelp,
            /*#__PURE__*/ (0, $nNhvg.jsx)("li", {
                children: "These tools are meant to support in-person games."
            }),
            /*#__PURE__*/ (0, $nNhvg.jsxs)("li", {
                children: [
                    "The wiki has a",
                    " ",
                    /*#__PURE__*/ (0, $nNhvg.jsx)("a", {
                        href: "https://wiki.bloodontheclocktower.com/Rules_Explanation",
                        children: "rules explanation"
                    }),
                    " ",
                    "for new players."
                ]
            })
        ]
    });
}
const $1f805259eb2a0f16$var$BlackBtn = /*#__PURE__*/ (0, $8jRlF.default)("a", {
    target: "e1o76wsj0"
})("&,&:visited{color:white;background-color:black;border-radius:0.25rem;padding:0.25rem;line-height:1.7rem;&:hover{background-color:", (0, $gUqIv.lighten)(0.3, "black"), ";text-decoration:none;}}");
function $1f805259eb2a0f16$var$GitHubLink() {
    return /*#__PURE__*/ (0, $nNhvg.jsxs)($1f805259eb2a0f16$var$BlackBtn, {
        href: "https://github.com/tchajed/botc-tools",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $nNhvg.jsx)((0, $jEyqx.FontAwesomeIcon), {
                icon: [
                    "fab",
                    "github"
                ]
            }),
            "\xa0 GitHub source"
        ]
    });
}
function $1f805259eb2a0f16$var$EnterPasswordButton(props) {
    const [isCorrect, setIsCorrect] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        (0, $exXH6.isCorrectPassword)(props.password).then((correct)=>{
            setIsCorrect(correct);
        });
    }, [
        props.password
    ]);
    const onClick = ()=>{
        if (isCorrect) {
            props.setPassword("");
            return;
        }
        const password = prompt("Enter password");
        if (!password) return;
        (0, $exXH6.isCorrectPassword)(password).then((correct)=>{
            if (correct) {
                props.setPassword(password);
                setIsCorrect(true);
            }
        });
    };
    const text = isCorrect ? "Clear password" : "Enter password";
    return /*#__PURE__*/ (0, $nNhvg.jsx)($1f805259eb2a0f16$var$BlackBtn, {
        onClick: onClick,
        children: text
    });
}
function $1f805259eb2a0f16$var$showUpdateTime(date) {
    const dayDifference = (0, $beed7bfc27ef6789$export$86415ebf4eb36b8c)(new Date(), date);
    if (dayDifference == 0) return "today";
    if (dayDifference == 1) return "yesterday";
    return date.toLocaleDateString();
// TODO: couldn't get this to work with date-fns formatting
/*
  if (dayDifference < 30) {
    return formatDate(date, "MMM d", { locale: enUS });
  }
  return formatDate(date, "MMM d, y", { locale: enUS });
  */ }
var $1f805259eb2a0f16$var$_ref = {
    name: "1l6qcox",
    styles: "margin-top:3em;font-size:90%;max-width:10rem;float:right"
};
var $1f805259eb2a0f16$var$_ref4 = {
    name: "1aujq9w",
    styles: "text-align:justify"
};
function $1f805259eb2a0f16$var$Footer(props) {
    return /*#__PURE__*/ (0, $nNhvg.jsxs)("footer", {
        css: $1f805259eb2a0f16$var$_ref,
        children: [
            /*#__PURE__*/ (0, $nNhvg.jsxs)("p", {
                children: [
                    "Scripts updated ",
                    $1f805259eb2a0f16$var$showUpdateTime(props.lastUpdate)
                ]
            }),
            /*#__PURE__*/ (0, $nNhvg.jsx)($1f805259eb2a0f16$var$GitHubLink, {}),
            /*#__PURE__*/ (0, $nNhvg.jsx)("br", {}),
            /*#__PURE__*/ (0, $nNhvg.jsx)($1f805259eb2a0f16$var$EnterPasswordButton, {
                ...props
            }),
            /*#__PURE__*/ (0, $nNhvg.jsx)("p", {
                css: $1f805259eb2a0f16$var$_ref4,
                children: "This is an unofficial app not affiliated with The Pandamonium Institute."
            })
        ]
    });
}
const $1f805259eb2a0f16$var$scriptLinkStyle = {
    link: {
        name: "uro5cw",
        styles: "float:right;margin-top:1rem;font-size:90%"
    },
    title: {
        name: "659d5m",
        styles: "display:inline-block;vertical-align:bottom;max-width:8rem;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
    }
};
function $1f805259eb2a0f16$export$86fbec116b87613f(props) {
    const [password, setPassword] = (0, $acw62.useState)("");
    const [authenticated, setAuthenticated] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        (0, $exXH6.isCorrectPassword)(password).then((correct)=>{
            setAuthenticated(correct);
        });
    }, [
        password
    ]);
    const scripts = props.scriptsFile.scripts;
    const lastUpdate = new Date(Date.parse(props.scriptsFile.lastUpdate));
    const baseThree = scripts.filter((s)=>(0, $f9f9b2db1313b9af$export$54adcc344e3cab6a).includes(s.pk));
    baseThree.sort((s1, s2)=>s1.pk - s2.pk);
    const custom = scripts.filter((s)=>{
        if ((0, $f9f9b2db1313b9af$export$54adcc344e3cab6a).includes(s.pk)) return false;
        return authenticated || !s.allAmne;
    });
    function removePrefix(s, prefix) {
        if (s.startsWith(prefix)) return s.substring(prefix.length);
        return s;
    }
    function hashQuery() {
        return decodeURI(removePrefix(window.location.hash, "#"));
    }
    const [query, setQuery] = (0, $acw62.useState)(hashQuery());
    const [lastScript, setLastScript] = (0, $acw62.useState)(null);
    // arbitrary state that changes periodically, to force a re-render
    const [elapsedMinutes, setElapsedMinutes] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const i = setInterval(()=>{
            setElapsedMinutes((m)=>m + 1);
        }, 60000);
        return ()=>clearInterval(i);
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $h3I9t.latestScript)().then((s)=>{
            if (!s) return;
            const elapsedMs = new Date().getDate() - s.lastSave.getDate();
            if (elapsedMs <= 5400000) setLastScript(s);
        });
        (0, $h3I9t.getPassword)().then((p)=>{
            setPassword(p);
        });
    }, [
        elapsedMinutes
    ]);
    const setAndStorePassword = (password)=>{
        setPassword(password);
        (0, $h3I9t.storePassword)(password);
    };
    (0, $acw62.useEffect)(()=>{
        // explicit typecast since we want a dynamic global property to communicate
        // with service worker
        window["reloadSafe"] = true;
    }, []);
    (0, $acw62.useEffect)(()=>{
        // clear saved scroll position on the assumption we're changing scripts (we
        // could remember which script it's for and invalidate more conservatively
        // but this is a minor bit of state)
        (0, $3NL81.clearSavedScroll)();
    }, []);
    (0, $acw62.useEffect)(()=>{
        window.onhashchange = ()=>{
            const newQuery = hashQuery();
            if (newQuery != "" && (0, $86b312579ea6ab09$export$bbd3890ed397f36c)(newQuery) != (0, $86b312579ea6ab09$export$bbd3890ed397f36c)(query)) setQuery(newQuery);
        };
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $nNhvg.jsx)((0, $dW2n4.a), {
        theme: (0, $hIYVk.theme),
        children: /*#__PURE__*/ (0, $nNhvg.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $nNhvg.jsx)((0, $8zogs.Global), {
                    styles: [
                        (0, $j4XaA.GlobalStyle),
                        (0, $d90584698df86283$export$6d90db48325da75),
                        "",
                        ""
                    ]
                }),
                /*#__PURE__*/ (0, $nNhvg.jsxs)("div", {
                    className: "main",
                    children: [
                        lastScript && /*#__PURE__*/ (0, $nNhvg.jsx)("div", {
                            css: $1f805259eb2a0f16$var$scriptLinkStyle.link,
                            children: /*#__PURE__*/ (0, $nNhvg.jsxs)($1f805259eb2a0f16$var$BtnLink, {
                                href: (0, $3NL81.pageUrl)("assign", lastScript.id.toString()),
                                children: [
                                    /*#__PURE__*/ (0, $nNhvg.jsx)("span", {
                                        css: $1f805259eb2a0f16$var$scriptLinkStyle.title,
                                        children: lastScript.scriptTitle
                                    }),
                                    "\xa0 ",
                                    /*#__PURE__*/ (0, $nNhvg.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                        icon: "chevron-right"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $nNhvg.jsx)("h1", {
                            children: "BotC tools"
                        }),
                        /*#__PURE__*/ (0, $nNhvg.jsx)("h2", {
                            children: "Base 3"
                        }),
                        /*#__PURE__*/ (0, $nNhvg.jsx)((0, $f9f9b2db1313b9af$export$3e15fc05ce864229), {
                            scripts: baseThree
                        }),
                        /*#__PURE__*/ (0, $nNhvg.jsx)("h2", {
                            children: "Custom"
                        }),
                        /*#__PURE__*/ (0, $nNhvg.jsx)((0, $dbe52e5def8afa3a$export$aee53da69e9839be), {
                            scripts: custom,
                            query: query,
                            setQuery: setQuery
                        }),
                        /*#__PURE__*/ (0, $nNhvg.jsx)($1f805259eb2a0f16$var$HelpText, {}),
                        /*#__PURE__*/ (0, $nNhvg.jsx)($1f805259eb2a0f16$var$Footer, {
                            lastUpdate: lastUpdate,
                            password: password,
                            setPassword: setAndStorePassword
                        })
                    ]
                })
            ]
        })
    });
}



var $h3I9t = parcelRequire("h3I9t");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");
async function $b263d56e412b955b$var$init() {
    const app = document.getElementById("app");
    if (!app) return;
    (0, $h3I9t.initStorage)();
    const scriptsFile = await (0, $5jI6L.getScripts)();
    const root = (0, $aRPiL.createRoot)(app);
    root.render(/*#__PURE__*/ (0, $nNhvg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
        children: /*#__PURE__*/ (0, $nNhvg.jsx)((0, $1f805259eb2a0f16$export$86fbec116b87613f), {
            scriptsFile: scriptsFile
        })
    }));
}
$b263d56e412b955b$var$init();


//# sourceMappingURL=index.aaa67f44.js.map
